import { gql, useQuery } from "@apollo/client";
import { useKeycloak } from "providers/KeycloakProvider";

const COMPLETED_DATE_INFO_QUERY = gql`
  query GetUserInfo($contactId: Long!) {
    contact(id: $contactId) {
      profileDataString
      createdDate
    }
  }
`;

export interface UserInfoQuery {
  contact?: {
    profileDataString?: string;
    createdDate?: string;
  };
}

export function useGetPortfolioCompletedDate(
  selectedContactId?: string | number
) {
  // TODO: fix this
  const { linkedContact } = useKeycloak();

  const contactId = selectedContactId
    ? Number(selectedContactId)
    : Number(linkedContact) || 173;

  const { loading, error, data } = useQuery<UserInfoQuery>(
    COMPLETED_DATE_INFO_QUERY,
    {
      variables: {
        contactId,
      },
      // Use cache-first to survive component remounts
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      onError: (error) => {
        console.error(
          "Error fetching user info:",
          JSON.stringify(error, null, 2)
        ); // Ensure error is serialized
      },
    }
  );

  // Use data if available, fall back to previousData to handle remounts
  const contactData = data?.contact;

  const processedData = contactData
    ? {
        completeDate: (() => {
          if (!contactData.profileDataString) return undefined;

          // Parse the profileDataString to extract ncontact_profiling_completeDate
          const lines = contactData.profileDataString.split(",\n");
          for (const line of lines) {
            const [key, value] = line.split("=");
            if (key === "contact.profiling.ncontact_profiling_completeDate") {
              return value;
            }
          }
          return undefined;
        })(),
        createdDate: contactData.createdDate,
      }
    : undefined;

  return {
    loading: loading && !contactData, // Only truly loading if we have no data at all
    error,
    data: processedData,
  };
}
